import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { TOGGLE_ENTRY_STRATEGY } from './actionTypes';
import { toggleEntryStrategyFailure, toggleEntryStrategySuccess } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

// Is user register successfull then direct plot user in redux.
function* toggleEntryStrategy({ payload: { token, id, active, history } }) {
  try {
    const response = yield call(entryStrategiesAPI.toggleEntryStrategy, { token, id, active });
    yield put(toggleEntryStrategySuccess(response));
    history.go();
  } catch (error) {
    yield put(toggleEntryStrategyFailure(error));
  }
}

export function* watchToggleEntryStrategy() {
  yield takeEvery(TOGGLE_ENTRY_STRATEGY, toggleEntryStrategy);
}

function* toggleEntryStrategySaga() {
  yield all([fork(watchToggleEntryStrategy)]);
}

export default toggleEntryStrategySaga;
